
import { cloneDeep } from 'lodash'
import { commonfunc } from '~/mixin/common'
import { pdMixin } from '@/mixin/pd/pdMixin'
import { rules } from '~/mixin/common/product/productRules'
import spbkMixin from '@/mixin/or/spbkMixin'
import { productDetailNavMixin } from '~/mixin/common/product/productDetailNavMixin'
import CommonButton from '@/components/common/button/CommonButton.vue'

// import CommonImage from '~/components/common/CommonImage.vue'
import ProductListSwipe from '~/components/organism/common/product/ProductListSwipe.vue'
import { pushGtmData } from '~/utils/gtm'
import Tooltip from '~/components/common/tooltip/Tooltip.vue'
import LayerShareSns from '@/components/common/shareSns.vue' // 공유하기 팝업
import DaisoDialog from '~/components/common/modal/DaisoDialog.vue'
import DaisoImage from '~/components/common/DaisoImage.vue'

export default {
  name: 'ProductListWrapper',
  components: {
    // CommonImage,
    DaisoImage,
    CommonButton,
    ProductListSwipe,
    Tooltip,
    LayerShareSns,
    DaisoDialog
  },
  mixins: [commonfunc, rules, spbkMixin, pdMixin, productDetailNavMixin],
  props: {
    editRadio: {
      type: Boolean,
      default: false
    },
    details: {
      type: Object,
      default: () => {}
    },
    productList: {
      type: Array,
      default: () => []
    },
    listType: {
      type: String,
      default: 'card2'
    },
    useSwipe: {
      type: Boolean,
      default: true
    },
    useSwipePagination: {
      type: Boolean,
      default: true
    },
    nested: {
      type: Boolean,
      default: false
    },
    chunkCount: {
      type: Number,
      default: 6
    },
    useBundleSwipe: {
      type: Boolean,
      default: false
    },
    useLoop: {
      type: Boolean,
      default: false
    },
    showController: {
      type: Boolean,
      default: false
    },
    isRankingProd: {
      type: Boolean,
      default: false
    },
    isNotifyProd: {
      type: Boolean,
      default: false
    },
    variantIndex: {
      type: Number,
      default: null
    },
    useChipButton: {
      type: Boolean,
      default: false
    },
    chipsList: {
      type: Array,
      default: () => []
    },
    activeChip: {
      type: [String, Number],
      default: null
    },
    tabIndicator: {
      type: Array,
      default: () => {
        return []
      }
    },
    quickYn: {
      type: Boolean,
      default: false
    },
    exhType: { // 상품전시유형코드
      type: String,
      default: ''
    },
    recmYn: { // 추천 솔루션 조회 여부
      type: Boolean,
      default: false
    },
    recentViewTrackable: {
      type: Boolean,
      default: true
    },
    recentViewAfterReview: {
      type: Boolean,
      default: false
    },
    isProdGift: { // 상품권 여부
      type: Boolean,
      default: false
    },
    editChk: {
      type: Boolean,
      default: false
    },
    ntcnType: {
      type: String,
      default: ''
    },
    msStoreYn: {
      type: Boolean,
      default: false
    },
    selectedPdNo: {
      type: String,
      default: ''
    },
    border: {
      type: Boolean,
      default: false
    },
    customSpbkSecd: {
      type: String,
      default: ''
    },
    customFlags: {
      type: [Array, Function],
      default: () => {
        return []
      }
    },
    customTopFlags: {
      type: Array,
      default: () => {
        return []
      }
    },
    searchTerm: {
      type: String,
      default: ''
    },
    isMainList: {
      type: Boolean,
      default: false
    },
    exbtNo: {
      type: String,
      default: null
    },
    showMoreBtn: {
      type: Boolean,
      default: false
    },
    newPdCmptmtNo: {
      type: String,
      default: null
    },
    trackingId: {
      type: String,
      default: null
    },
    isKkulmix: {
      type: Boolean,
      default: false,
    },
    jobCd: { // 업무영역(상품,배송 모듈에 사용)
      type: String,
      default: ''
    },
  },
  data () {
    return {
      isZziming: false,
      isAlarming: false,
      shareData: {},
      alarmComplete: false,
      showNewnessBanner: false,
      ntcnText: '카카오 알림톡, 앱 푸시로<br> 알려드릴게요.'
    }
  },
  computed: {
    isBulkOrderUnit () {
      return this.bulkYn || this.$route.path.includes('bulkOrder') || this.$route.params.cartType === 'bulkOrder' || this.$route.query.cartType === 'bulkOrder'
    },
    isQuickExhibition () { // 오늘배송 GNB, 오늘배송 기획전 여부 (최초 GNB 노출 요청은 FO만이었으나 추후 확장을 대비해 C118 조건은 남겨둍니다.)
      return this.quickYn ||
        this.$route.path.includes('C118') ||
        this.$route.fullPath.includes('exbtNo=519') ||
        this.$route.params.cartType === 'quickOrder' ||
        this.$route.query.cartType === 'quickOrder'
    },
    isPickupOrderUnit () {
      return this.pkupYn || this.$route.path.includes('pickupOrder') || this.$route.params.cartType === 'pickupOrder' || this.$route.query.cartType === 'pickupOrder'
    }
  },
  watch: {
    $route () {
      this.alarmComplete = false
    }
  },
  deactivated () {
    this.alarmComplete = false
  },
  methods: {
    getSwiper () {
      return this.$refs.productSwipe?.getSwiper()
    },
    getDlvChip () {
      const path = this.$route.path
      if (path.includes('/quickOrder')) { return '05' }
      if (path.includes('/pickupOrder')) { return '02' }
      if (path.includes('/bulkOrder')) { return '04' }
      return null
    },
    changeSwipeActiveTab (index) {
      this.$emit('activeTab', index)
    },
    goProductDetail (obj) {
      if (this.ntcnType === 'newPd') {
        this.openToast('신상품 출시 예정 정보는 모바일에서 확인 가능합니다.')
        return
      }
      this.sendFeedback(obj)
      if (this.newPdCmptmtNo) {
        pushGtmData(`prod_click_${this.newPdCmptmtNo}_${obj.pdNo || ''}`, 'newshorts')
      }
      if (this.msStoreYn) {
        this.$emit('clickLink', obj)
      } else {
        console.log(obj)
        this.detailAdultCert(obj)
        this.$emit('clickLink')
      }
    },
    changeRadio (value, index) {
      this.$emit('changeRadio', value, index)
    },
    sendFeedback (obj) {
      sessionStorage.setItem('recentViewProdIndex', JSON.stringify({ pdNo: obj.pdNo, smallExhCtgrNo: obj.exhSmallCtgrNo, isRecm: this.recmYn, trackable: this.recentViewTrackable, afterReview: this.recentViewAfterReview }))
      if (this.isMainList) {
        sessionStorage.removeItem('viewIndex')
      }
      if (this.isNotEmpty(obj.keyword) || this.isNotEmpty(this.searchTerm)) {
        console.log('sendfeedback 호출 ', obj)
        const params = {
          ip: process.env.SSN_FD_IP,
          port: '5555', // 고정값
          collection: 'GOODS',
          keyword: this.isNotEmpty(obj.keyword) ? obj.keyword : this.searchTerm,
          clickedId: obj.pdNo,
          clickCount: 1,
          extInfos: obj.exhLargeCtgrNo + '>' + obj.exhMiddleCtgrNo + '>' + obj.exhSmallCtgrNo + '>' + obj.newPdYn
        }
        this.$AxiosBuilder
          .params(params)
          .baseURL(process.env.API_SSN_FD_BASE_URL)
          .build()
          .get('/sendFeedback')
          .then((res) => {
            console.log(res)
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    async addCart (obj) {
      console.log(obj)
      if (obj.buyLmtAgeCd === '03' && this.adltCtfcYn !== 'Y') {
        if (this.mb.mbMngNo !== undefined && this.adltCtfcCd === '02') { // 로그인되어 있고 성인인증 미인증
          if (await this.confirm(this.$t('PD.CERTIFY_ADULT'), { center: true, dangerouslyUseHTMLString: true })) {
            const nowPath = this.$route.fullPath
            this.$router.push({
              name: 'mb-mbc-SCR_MBC_0110A_01',
              path: '/mb/mbc/SCR_MBC_0110A_01',
              params: { redirectUrl: nowPath } // redirectUrl: 인증완료 후 리턴할 이전 화면
            })
          }
        } else if (this.mb.mbMngNo !== undefined && this.adltCtfcCd === '03') { // 로그인 되어 있고 성인인증 인증만료
          if (await this.confirm(this.$t('PD.CERTIFY_ADULT_EXPIRED'), { center: true, dangerouslyUseHTMLString: true })) {
            const nowPath = this.$route.fullPath
            this.$router.push({
              name: 'mb-mbc-SCR_MBC_0110A_01',
              path: '/mb/mbc/SCR_MBC_0110A_01',
              params: { redirectUrl: nowPath } // redirectUrl: 인증완료 후 리턴할 이전 화면
            })
          }
        } else { // 미로그인인 경우 로그인
          // eslint-disable-next-line no-lonely-if
          if (!this.mb.mbMngNo) {
            const nowPath = this.$route.fullPath
            this.$router.push({
              name: 'mb-mbb-SCR_MBB_0097A',
              params: { redirectUrl: nowPath } // redirectUrl: 로그인 후 리턴할 이전 화면
            })
          }
        }
      } else {
        /* 덕용상품이고, 낱개판매 안할때
            * 박스상품은 덕용상품은 아니지만 pkgYn = ' Y' 이다.
            * 하지만 상품상세로 넘어가지 않고 상품 썸네일 내 장바구니 담기 시 중포수량으로 담겨야하므로 !this.isBoxGoods(obj) 를 추가한다.
        */
        const epieceSleYn = obj.epieceSleYn ?? obj.EPIECE_SLE_YN

        // 옵션 상품이거나 낱개판매불가 상품,  상품권일 경우 상세 페이지 이동
        if (obj?.optPdYn === 'Y' || obj?.pdTy === '03' || (epieceSleYn === 'N')) {
          if (this.newPdCmptmtNo && obj?.optPdYn === 'Y') {
            pushGtmData(`prod_op_${this.newPdCmptmtNo}_${obj.pdNo || ''}`, 'newshorts')
          }
          if (obj?.popupYn) {
            this.$emit('addCartOptPdOrPkgEpieceSle', obj.pdNo)
          } else {
            const query = { pdNo: obj.pdNo, recmYn: obj.recmYn ? 'Y' : 'N' }
            const dlvChip = this.getDlvChip()
            if (dlvChip) { query.dlvChip = dlvChip }
            if (this.$route.path === '/pd/pdr/SCR_PDR_0001' && this.$route.query.pdNo === query.pdNo) {
              window.location.reload()
            } else {
              this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query })
            }
          }
          return
        }

        const productInfo = cloneDeep(obj)
        console.log(productInfo)
        console.log('~~뒤로가기quickyn', this.quickYn, obj.quickOrPsblYn)
        console.log('~~뒤로가기', this.$route.path, this.isQuickExhibition)

        productInfo.fbYn = this.fbYn
        productInfo.recmYn = this.recmYn
        productInfo.isBulkOrderUnit = this.isBulkOrderUnit
        productInfo.optCn = ''
        productInfo.epieceSleYn = epieceSleYn

        if (this.isNotEmpty(this.$route.params.spbkSeCd)) {
          productInfo.spbkSeCd = this.$route.params.spbkSeCd
        }

        if (this.customSpbkSecd !== '') {
          productInfo.spbkSeCd = this.customSpbkSecd
        }

        productInfo.spbkPkgYn = this.isBoxGoods(obj) ? 'Y' : ''

        if ((productInfo.QUICK_OR_PSBL_YN === 'Y' && this.isQuickExhibition) || (productInfo.quickOrPsblYn === 'Y' && this.isQuickExhibition)) {
          productInfo.spbkSeCd = '05'
        }

        if (productInfo.pkupOrPsblYn === 'Y' && this.isPickupOrderUnit) {
          productInfo.spbkSeCd = '02'
        }

        if (this.jobCd === 'pd') {
          productInfo.spbkSeCd = this.spbkSeCd
          productInfo.optPdYn = obj.optPdYn === true ? 'Y' : 'N'
          productInfo.bunYn = obj.bundle === true ? 'Y' : 'N'
        }

        if (this.jobCd === 'fb') {
          productInfo.spbkSeCd = this.spbkSeCd
        }

        const isSuccess = await this.clickAddSpbkBtn(productInfo)

        console.log('##########################!!!!!!!!!!!', isSuccess)
        console.log(isSuccess)
        console.log(this.exbtNo)

        const effectiveExbtNo = this.$route.path.includes('spexhbt')
          ? this.$route.query.exbtNo
          : this.exbtNo

        if (isSuccess && effectiveExbtNo) {
          try {
            await this.$AxiosBuilder
              .build()
              .post(`/ds/curation/cart-count/${effectiveExbtNo}`)
            console.log(`기획전 장바구니 카운트 증가 성공: exbtNo=${effectiveExbtNo}`)
          } catch (e) {
            console.error('기획전 장바구니 카운트 증가 실패', e)
          }
        }

        if (isSuccess && this.newPdCmptmtNo) {
          pushGtmData(`prod_add_${this.newPdCmptmtNo}_${obj.pdNo || ''}`, 'newshorts')
          try {
            await this.$AxiosBuilder
              .build()
              .post(`/ds/new/cart-count/${this.newPdCmptmtNo}`)
            console.log(`신상품 구좌 장바구니 카운트 증가 성공: newPdCmptmtNo=${this.newPdCmptmtNo}`)
          } catch (e) {
            console.error('신상품 구좌 장바구니 카운트 증가 실패', e)
          }
        }
      }
    },
    async likeProduct (obj) {
      const mbMngNo = this.$store.getters['session/getMbMngNo']
      if (!this.isNotEmpty(mbMngNo)) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }

      if (this.isZziming) {
        return
      }

      this.isZziming = true
      try {
        const zzimRes = await this.$store.dispatch('zzim/toggleZzim', obj.pdNo)
        let zzimYn
        if (zzimRes.data.success) {
          zzimYn = zzimRes.data.extraData.zzimYn ? 'Y' : 'N'
          const msg = zzimYn === 'Y' ? this.$t('PD.ZZIM_SUCCESS') : this.$t('PD.ZZIM_CANCEL')
          if (zzimYn === 'Y') {
            this.$createToast('<span>' + msg + '</span><a href="/pd/pdm/SCR_PDM_0011?currentTab=1" class="link-txt arrow">보러가기</a>')
            this.callAirBridgeForAddToWishiList(obj)
            this.$blux.basicEventSend('wishlist', { pdNo: obj.pdNo })
            if (this.$route.path === '/pd/pdm/SCR_PDM_0011') {
              this.$emit('reloadList')
            }
          } else if (this.$route.path === '/pd/pdm/SCR_PDM_0011') {
            this.$emit('reloadList')
            this.$createToast(msg)
          } else {
            this.$createToast(msg)
          }
        } else if (zzimRes.data.message === 'OVER') {
          this.confirm(this.$t('PD.ZZIM_LIMIT_OVER', { limitCnt: zzimRes.data.extraString }), {
            yes: '찜한 상품 바로가기',
            no: '확인',
            okCallback: () => {
              this.$router.push({ path: '/pd/pdm/SCR_PDM_0011?currentTab=1' })
            }
          })
        }
      } catch (e) {
        console.error('찜 토글 실패:', e)
      } finally {
        this.isZziming = false
      }

      pushGtmData(obj, 'wishlist') // 찜하기 성공시 GTM DataLayer Push 실행
    },
    async alarmProduct ({ evt, item }) {
      const mbMngNo = this.$store.getters['session/getMbMngNo']
      if (!this.isNotEmpty(mbMngNo)) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }

      if (this.isAlarming) {
        return
      }

      this.isAlarming = true
      try {
        const ancYn = evt ? 'Y' : 'N'
        const newAncYn = await this.$store.dispatch('anc/toggleAnc', {
          pdNo: item.pdNo,
          mbMngNo: this.getMbMngNo(),
          currentAncYn: ancYn
        })
        this.$emit('alarm-toggle-cnt', { pdNo: item.pdNo, ancYn: newAncYn === 'N' ? 'N' : 'Y' })
        if (newAncYn === 'Y') {
          console.log('this.jobCd: ', this.jobCd)
          if (this.jobCd === 'pd' || this.isNotifyProd) { // 오픈런 페이지만 토스트
            this.$createToast(this.$t('PD.NOTIFY_SUCCESS'))
          } else {
            await this.alarmSuccessPop()
          }
        } else if (newAncYn === 'N') {
          this.openToast(this.$t('PD.NOTIFY_CANCEL'))
        } else if (newAncYn) {
          if (newAncYn === '이미 오픈런알림을 신청하였습니다.') {
            this.$createToast(newAncYn + '</span><a href="/pd/pdm/SCR_PDM_0002" class="link-txt arrow">신청내역 확인</a>')
          } else {
            this.$createToast(newAncYn)
          }
        }
      } catch (e) {
        console.error('판매알림 토글 실패:', e)
      } finally {
        this.isAlarming = false
      }
    },
    callAirBridgeForAddToWishiList (obj) {
      const productInfo = new this.$airbridge.ProductObject(obj.pdNo, obj.exhPdNm, obj.pdPrc, obj.brndCd, obj.onlLclNm, 1, '')
      this.$airbridge.addToWishiList(productInfo)
    },
    goBannerDetail (obj) {
      console.log('banrLinkMvmnTyCd :', obj.banrLinkMvmnTyCd)

      // HTML 엔티티를 원래 문자로 변환
      const linkUrl = this.unescape(obj.pcomLinkUrl || '')

      if (obj.banrLinkMvmnTyCd === '02') {
        window.open(linkUrl)
      } else {
        this.$router.push(linkUrl)
      }
    },
    showRplc (obj) {
      this.$emit('clickRplc', obj)
    },
    shareProduct (obj) {
      console.log('오픈런 상품 정보' + obj)
      this.shareData = {
        url: process.env.WEB_BASE_URL + '/ds/prir?scrollTo=pdNo-' + obj.pdNo,
        title: obj.pdMStrgyInfoVO.tmplSj,
        description: obj.pdMStrgyInfoVO.tmplCn,
        imgUrl: obj.pdMStrgyInfoVO.imgUrl,
        singleButton: true
      }
      this.$refs.layerShareSns.snsVisible = true
    },
    changeInput (value, index) {
      this.$emit('changeInput', value, index)
    },
    clickCancel (obj) {
      this.$emit('clickCancel', obj)
    },
    clickDelete (obj) {
      this.$emit('clickDelete', obj)
    },
    async alarmSuccessPop () {
      const subscribed = await this.isNewnessSubscribed()
      this.showNewnessBanner = !subscribed
      this.alarmComplete = true
    },
    async isNewnessSubscribed () {
      return await this.$AxiosBuilder
        .data()
        .build()
        .post('/mb/mbc/sbsc/list')
        .then((res) => {
          if (res.data.success) {
            this.sbscList = res.data.data.sbscList
            return this.sbscList.length > 0
          }
          return false
        })
        .catch((e) => {
          throw new Error(e)
        })
    },
    moveNewPdClub () {
      this.$router.push({ path: '/ds/new_club' })
    },
    setEmblemImg (item) {
      if (item?.pcImgAtchFileUrl) {
        return item?.pcImgAtchFileUrl
      } else if (item?.emblmPcImgAtchFileUrl) {
        return item?.emblmPcImgAtchFileUrl?.replace('\n', '')
      } else if (item?.emblm_pc_img_atch_file_url) {
        return item?.emblm_pc_img_atch_file_url?.replace('\n', '')
      } else {
        return null
      }
    },
    setEmblemAlt (item) {
      if (item?.emblmNm) {
        return item?.emblmNm
      } else if (item?.emblm_nm) {
        return item?.emblm_nm
      }
      return '프로모션'
    },
    openToast (msg, dur) {
      this.$notify({
        message: msg,
        position: 'bottom-left',
        showClose: false,
        duration: dur || 3000,
        onClick: () => { this.$notify.closeAll() }
      })
    }
  }
}
